import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {AppConfigEnvironment} from '@shared/models/appconfig-environment.model';
import {AppConfigEnvironmentService} from '@shared/service/appconfig-environment.service';
import { logger } from '@app/shared/utilities/logger.model';
import { Utilities as U } from '@app/shared/utilities/utilities.model';
import {TranslateContext, TranslatePipe} from '@shared/pipes/translate.pipe';


@Injectable({
	providedIn: 'root'
})
export class InnerMessageAdministrationService {
	private pushInnerMessagesSubject = new Subject<InnerMessageAdministration>();
	public pushInnerMessagesObservable = this.pushInnerMessagesSubject.asObservable();

	private removeInnerMessagesSubject = new Subject<string>();
	public removeInnerMessagesObservable = this.removeInnerMessagesSubject.asObservable();
	environment: AppConfigEnvironment;
	language: string;
	messages: { key: string };

	constructor(
		private appConfig: AppConfigEnvironmentService,
		private translatePipe: TranslatePipe,
	) {
		this.environment = this.appConfig.Environment;
		this.language = this.environment.SERVER_DATE_LOCATION;
		switch (this.language) {
			case 'it':
			default :
				this.messages = require('./messages/messages.ita.json');
				break;
		}
	}

	pushInnerMessage(innerMessage: InnerMessageAdministration) {
		this.pushInnerMessagesSubject.next(innerMessage);
	}

	removeInnerMessage(idInnerMessage: string) {
		this.removeInnerMessagesSubject.next(idInnerMessage);
	}

	deleteAll() {
		this.removeInnerMessagesSubject.next(InnerMessageAdministration.DELETE_ALL);
	}

	messageToPush(generatedMessage: GeneratedInnerMessageAdministration): InnerMessageAdministration {
		let innerMessage: InnerMessageAdministration;
		if (generatedMessage.code) {
			if (generatedMessage.message) {
				innerMessage = new InnerMessageAdministration(this.getMessage(generatedMessage.code, generatedMessage.message), generatedMessage.type, null, true);
			} else {
				innerMessage = new InnerMessageAdministration(this.getMessage(generatedMessage.code), generatedMessage.type, null, true);
			}
		} else {
			if (generatedMessage.type === InnerMessageAdministration.TYPE_SUCCESS) {
				generatedMessage.code = InnerMessageAdministration.GENERIC_SUCCESS;
			} else {
				generatedMessage.code = InnerMessageAdministration.GENERIC_ERROR;
			}
			innerMessage = new InnerMessageAdministration(this.getMessage(generatedMessage.code), generatedMessage.type, null, true);
		}
		return innerMessage;
	}

	getMessage(code: string, message?: string) {

		try {
			
			let parameters;
	
			// MOCK
			// message = "File type ('text/csv') not supported";
			// message = "File type not supported";
			
			if (message) {
				// TODO
				// la gestione dei parametri sarebbe da spostare sotto
				// solo se effettivamente è richiesta nel messaggio mappato...
				parameters = message.match(new RegExp('(?!\\(\')([^\']+)(?=\'\\))', 'g'));
				parameters ? parameters = parameters.reverse() : parameters = parameters;
			}
			const text = this.messages[code];
			if (text) {
				
				// vede se il messaggio mappato contiene dei parametri
				if (text.indexOf(`('%s')`) > -1) {

					// safe condition
					// se il messaggio del BE non contiene parametri, o sono sbagliati
					// restituire un messaggio di errore generico
					if (U.isEmpty(parameters)) {
						return this.translatePipe.transform('MESSAGGIO_ERRORE_GENERICO', TranslateContext.SHARED);
					}

					const slices = text.split(`('%s')`);
					return slices.reduce((prev, curr) => {
						const parameter = parameters.pop();
						return `${prev}${parameter ? parameter : ''}${curr}`
					});
				} else {
					return text;
				}
			} else {
				return message;
			}
		} catch (error) {
			logger.error('InnerMessageAdministrationService - getMessage - error parsing message: ', error);	
		}
	}
}

export class GeneratedInnerMessageAdministration {
	code: string;
	message: string;
	type: string;

	constructor(response: any) {

		let status;
		if (response._body) {
			status = JSON.parse(response._body).status;
		} else {
			status = response.status;
		}
		(status < 400) ? this.type = InnerMessageAdministration.TYPE_SUCCESS : this.type = InnerMessageAdministration.TYPE_ERROR;
		if (response._body) {
			this.code = JSON.parse(response._body).code;
			this.message = JSON.parse(response._body).message;
		} else {
			if (response.code) {
				this.code = response.code;
				this.message = response.message;
			} else {
				this.message = '';
				(this.type === InnerMessageAdministration.TYPE_SUCCESS) ? this.code = InnerMessageAdministration.GENERIC_SUCCESS : this.code = InnerMessageAdministration.GENERIC_ERROR;
			}
		}
	}
}

// @ts-ignore
export class InnerMessageAdministration {
	static DELETE_ALL: string = 'DELETE_ALL';

	static TYPE_SUCCESS: string = 'success';
	static TYPE_WARNING: string = 'warning';
	static TYPE_ERROR: string = 'error';
	static TYPE_INFO: string = 'info';

	static GENERIC_SUCCESS: string = 'ADMINISTRATION_RULES_GENERIC_SUCCESS';
	static GENERIC_ERROR: string = 'ADMINISTRATION_RULES_GENERIC_ERROR';

	// NEMO RULES
	static ADMINISTRATION_RULES_ERROR_DUPLICATE_IDENTIFIER: string = 'ADMINISTRATION_RULES_ERROR_DUPLICATE_IDENTIFIER';
	static ADMINISTRATION_RULES_ENGINE_CREATED: string = 'ADMINISTRATION_RULES_ENGINE_CREATED';
	static ADMINISTRATION_RULES_ENGINE_CREATE_ERROR: string = 'ADMINISTRATION_RULES_ENGINE_CREATE_ERROR';
	static ADMINISTRATION_RULES_ENGINE_UPDATED: string = 'ADMINISTRATION_RULES_ENGINE_UPDATED';
	static ADMINISTRATION_RULES_ENGINE_UPDATE_ERROR: string = 'ADMINISTRATION_RULES_ENGINE_UPDATE_ERROR';
	static ADMINISTRATION_RULES_ENGINE_DELETED: string = 'ADMINISTRATION_RULES_ENGINE_DELETED';
	static ADMINISTRATION_RULES_ENGINE_DELETE_ERROR: string = 'ADMINISTRATION_RULES_ENGINE_DELETE_ERROR';
	static ADMINISTRATION_RULES_ENGINE_BULK_DELETED: string = 'ADMINISTRATION_RULES_ENGINE_BULK_DELETED';
	static ADMINISTRATION_RULES_ENGINE_BULK_DELETE_ERROR: string = 'ADMINISTRATION_RULES_ENGINE_BULK_DELETE_ERROR';
	static ADMINISTRATION_RULES_JSON_SCHEMA_SAVED: string = 'ADMINISTRATION_RULES_JSON_SCHEMA_SAVED';
	static ADMINISTRATION_RULES_JSON_SCHEMA_SAVE_ERROR: string = 'ADMINISTRATION_RULES_JSON_SCHEMA_SAVE_ERROR';
	static ADMINISTRATION_RULES_ENGINE_BLOCK_STATUS_CHANGED_SUCCESS: string = 'ADMINISTRATION_RULES_ENGINE_BLOCK_STATUS_CHANGED_SUCCESS';
	static ADMINISTRATION_RULES_ENGINE_BLOCK_STATUS_CHANGED_ERROR: string = 'ADMINISTRATION_RULES_ENGINE_BLOCK_STATUS_CHANGED_ERROR';
	static ADMINISTRATION_RULES_ENGINE_RULE_CREATED: string = 'ADMINISTRATION_RULES_ENGINE_RULE_CREATED';
	static ADMINISTRATION_RULES_ENGINE_RULE_CREATE_ERROR: string = 'ADMINISTRATION_RULES_ENGINE_RULE_CREATE_ERROR';
	static ADMINISTRATION_RULES_ENGINE_RULE_UPDATED: string = 'ADMINISTRATION_RULES_ENGINE_RULE_UPDATED';
	static ADMINISTRATION_RULES_ENGINE_RULE_UPDATE_ERROR: string = 'ADMINISTRATION_RULES_ENGINE_RULE_UPDATE_ERROR';
	static ADMINISTRATION_RULES_ENGINE_RULE_DELETED: string = 'ADMINISTRATION_RULES_ENGINE_RULE_DELETED';
	static ADMINISTRATION_RULES_ENGINE_RULE_DELETE_ERROR: string = 'ADMINISTRATION_RULES_ENGINE_RULE_DELETE_ERROR';
	static ADMINISTRATION_RULES_ENGINE_RULE_SORTED: string = 'ADMINISTRATION_RULES_ENGINE_RULE_SORTED';
	static ADMINISTRATION_RULES_ENGINE_RULE_SORT_ERROR: string = 'ADMINISTRATION_RULES_ENGINE_RULE_SORT_ERROR';
	static ADMINISTRATION_RULES_ENGINE_RULES_BULK_DELETED: string = 'ADMINISTRATION_RULES_ENGINE_RULES_BULK_DELETED';
	static ADMINISTRATION_RULES_ENGINE_RULES_BULK_DELETE_ERROR: string = 'ADMINISTRATION_RULES_ENGINE_RULES_BULK_DELETE_ERROR';
	static ADMINISTRATION_RULES_ENGINE_RULES_BULK_CHANGE_STATUS: string = 'ADMINISTRATION_RULES_ENGINE_RULES_BULK_CHANGE_STATUS';
	static ADMINISTRATION_RULES_ENGINE_RULES_BULK_CHANGE_STATUS_ERROR: string = 'ADMINISTRATION_RULES_ENGINE_RULES_BULK_CHANGE_STATUS_ERROR';
	static ADMINISTRATION_RULES_ENGINE_RULE_CONDITION_CREATED: string = 'ADMINISTRATION_RULES_ENGINE_RULE_CONDITION_CREATED';
	static ADMINISTRATION_RULES_ENGINE_RULE_CONDITION_CREATE_ERROR: string = 'ADMINISTRATION_RULES_ENGINE_RULE_CONDITION_CREATE_ERROR';
	static ADMINISTRATION_RULES_ENGINE_RULE_CONDITION_UPDATED: string = 'ADMINISTRATION_RULES_ENGINE_RULE_CONDITION_UPDATED';
	static ADMINISTRATION_RULES_ENGINE_RULE_CONDITION_UPDATE_ERROR: string = 'ADMINISTRATION_RULES_ENGINE_RULE_CONDITION_UPDATE_ERROR';
	static ADMINISTRATION_RULES_ENGINE_RULE_CONDITION_DELETED: string = 'ADMINISTRATION_RULES_ENGINE_RULE_CONDITION_DELETED';
	static ADMINISTRATION_RULES_ENGINE_RULE_CONDITION_DELETE_ERROR: string = 'ADMINISTRATION_RULES_ENGINE_RULE_CONDITION_DELETE_ERROR';
	static ADMINISTRATION_EXPORT_COMPLETE: string = 'ADMINISTRATION_EXPORT_COMPLETE';

	// NEMO CHANNELING
	static ADMINISTRATION_CHANNELING_GROUP_CREATED: string = 'ADMINISTRATION_CHANNELING_GROUP_CREATED';
	static ADMINISTRATION_CHANNELING_GROUP_CREATE_ERROR: string = 'ADMINISTRATION_CHANNELING_GROUP_CREATE_ERROR';
	static ADMINISTRATION_CHANNELING_GROUP_UPDATED: string = 'ADMINISTRATION_CHANNELING_GROUP_UPDATED';
	static ADMINISTRATION_CHANNELING_GROUP_UPDATE_ERROR: string = 'ADMINISTRATION_CHANNELING_GROUP_UPDATE_ERROR';
	static ADMINISTRATION_CHANNELING_GROUP_DELETED: string = 'ADMINISTRATION_CHANNELING_GROUP_DELETED';
	static ADMINISTRATION_CHANNELING_GROUP_DELETE_ERROR: string = 'ADMINISTRATION_CHANNELING_GROUP_DELETE_ERROR';
	static ADMINISTRATION_CHANNELING_GROUP_BULK_DELETED: string = 'ADMINISTRATION_CHANNELING_GROUP_BULK_DELETED';
	static ADMINISTRATION_CHANNELING_GROUP_BULK_DELETE_ERROR: string = 'ADMINISTRATION_CHANNELING_GROUP_BULK_DELETE_ERROR';
	static ADMINISTRATION_CHANNELING_GET_PROFILES_ERROR: string = 'ADMINISTRATION_CHANNELING_GET_PROFILES_ERROR';
	static ADMINISTRATION_CHANNELING_GET_USER_PROFILE_ERROR: string = 'ADMINISTRATION_CHANNELING_GET_USER_PROFILE_ERROR';
	static ADMINISTRATION_CHANNELING_SEARCH_USERS_ERROR: string = 'ADMINISTRATION_CHANNELING_SEARCH_USERS_ERROR';
	static ADMINISTRATION_CHANNELING_USERS_ADDED_TO_GROUP: string = 'ADMINISTRATION_CHANNELING_USERS_ADDED_TO_GROUP';
	static ADMINISTRATION_CHANNELING_ADD_USERS_TO_GROUP_ERROR: string = 'ADMINISTRATION_CHANNELING_ADD_USERS_TO_GROUP_ERROR';
	static ADMINISTRATION_CHANNELING_REMOVE_USER_FROM_GROUP: string = 'ADMINISTRATION_CHANNELING_REMOVE_USER_FROM_GROUP';
	static ADMINISTRATION_CHANNELING_REMOVE_USER_FROM_GROUP_ERROR: string = 'ADMINISTRATION_CHANNELING_REMOVE_USER_FROM_GROUP_ERROR';
	static ADMINISTRATION_CHANNELING_GET_GROUP_USERS_ERROR: string = 'ADMINISTRATION_CHANNELING_GET_GROUP_USERS_ERROR';
	static ADMINISTRATION_CHANNELING_GET_GROUP_RULES_ERROR: string = 'ADMINISTRATION_CHANNELING_GET_GROUP_RULES_ERROR';
	static ADMINISTRATION_CHANNELING_GROUP_RULE_CREATED: string = 'ADMINISTRATION_CHANNELING_GROUP_RULE_CREATED';
	static ADMINISTRATION_CHANNELING_GROUP_RULE_CREATE_ERROR: string = 'ADMINISTRATION_CHANNELING_GROUP_RULE_CREATE_ERROR';
	static ADMINISTRATION_CHANNELING_GROUP_RULES_BULK_DELETED: string = 'ADMINISTRATION_CHANNELING_GROUP_RULES_BULK_DELETED';
	static ADMINISTRATION_CHANNELING_GROUP_RULES_BULK_DELETE_ERROR: string = 'ADMINISTRATION_CHANNELING_GROUP_RULES_BULK_DELETE_ERROR';
	static ADMINISTRATION_CHANNELING_GROUP_RULES_BULK_CHANGE_STATUS: string = 'ADMINISTRATION_CHANNELING_GROUP_RULES_BULK_CHANGE_STATUS';
	static ADMINISTRATION_CHANNELING_GROUP_RULES_BULK_CHANGE_STATUS_ERROR: string = 'ADMINISTRATION_CHANNELING_GROUP_RULES_BULK_CHANGE_STATUS_ERROR';
	static ADMINISTRATION_CHANNELING_GROUP_RULES_BULK_CLONE: string = 'ADMINISTRATION_CHANNELING_GROUP_RULES_BULK_CLONE';
	static ADMINISTRATION_CHANNELING_GROUP_RULES_BULK_CLONE_ERROR: string = 'ADMINISTRATION_CHANNELING_GROUP_RULES_BULK_CLONE_ERROR';
	static ADMINISTRATION_CHANNELING_RULE_DELETED: string = 'ADMINISTRATION_CHANNELING_RULE_DELETED';
	static ADMINISTRATION_CHANNELING_RULE_DELETE_ERROR: string = 'ADMINISTRATION_CHANNELING_RULE_DELETE_ERROR';
	static ADMINISTRATION_CHANNELING_RULE_UPDATED: string = 'ADMINISTRATION_CHANNELING_RULE_UPDATED';
	static ADMINISTRATION_CHANNELING_RULE_UPDATE_ERROR: string = 'ADMINISTRATION_CHANNELING_RULE_UPDATE_ERROR';
	static ADMINISTRATION_CHANNELING_RULES_SEARCH_ERROR: string = 'ADMINISTRATION_CHANNELING_RULES_SEARCH_ERROR';
	static ADMINISTRATION_CHANNELING_RULE_BULK_DELETED: string = 'ADMINISTRATION_CHANNELING_RULE_BULK_DELETED';
	static ADMINISTRATION_CHANNELING_RULE_BULK_DELETE_ERROR: string = 'ADMINISTRATION_CHANNELING_RULE_BULK_DELETE_ERROR';
	static ADMINISTRATION_CHANNELING_RULES_BULK_CHANGE_STATUS: string = 'ADMINISTRATION_CHANNELING_RULES_BULK_CHANGE_STATUS';
	static ADMINISTRATION_CHANNELING_RULES_BULK_CHANGE_STATUS_ERROR: string = 'ADMINISTRATION_CHANNELING_RULES_BULK_CHANGE_STATUS_ERROR';
	static ADMINISTRATION_CHANNELING_RULES_SORTED: string = 'ADMINISTRATION_CHANNELING_RULES_SORTED';
	static ADMINISTRATION_CHANNELING_RULES_SORT_ERROR: string = 'ADMINISTRATION_CHANNELING_RULES_SORT_ERROR';
	static ADMINISTRATION_CHANNELING_RULE_CONDITION_CREATED: string = 'ADMINISTRATION_CHANNELING_RULE_CONDITION_CREATED';
	static ADMINISTRATION_CHANNELING_RULE_CONDITION_CREATE_ERROR: string = 'ADMINISTRATION_CHANNELING_RULE_CONDITION_CREATE_ERROR';
	static ADMINISTRATION_CHANNELING_RULE_CONDITION_UPDATED: string = 'ADMINISTRATION_CHANNELING_RULE_CONDITION_UPDATED';
	static ADMINISTRATION_CHANNELING_RULE_CONDITION_UPDATE_ERROR: string = 'ADMINISTRATION_CHANNELING_RULE_CONDITION_UPDATE_ERROR';
	static ADMINISTRATION_CHANNELING_RULE_CONDITION_DELETED: string = 'ADMINISTRATION_CHANNELING_RULE_CONDITION_DELETED';
	static ADMINISTRATION_CHANNELING_RULE_CONDITION_DELETE_ERROR: string = 'ADMINISTRATION_CHANNELING_RULE_CONDITION_DELETE_ERROR';
	static ADMINISTRATION_USERS_LIST_CONDITION_ENABLE_DESIBLE: string = 'ADMINISTRATION_USERS_LIST_CONDITION_ENABLE_DESIBLE';
	static ADMINISTRATION_USERS_LIST_CONDITION_ENABLE_DESIBLE_ERROR: string = 'ADMINISTRATION_USERS_LIST_CONDITION_ENABLE_DESIBLE_ERROR';
	static ADMINISTRATION_USERS_LIST_CONDITION_LOAD_NORESULT_ERROR: string = 'ADMINISTRATION_USERS_LIST_CONDITION_LOAD_NORESULT_ERROR';
	static ADMINISTRATION_USERS_LIST_CONDITION_LOAD_SERVER_ERROR: string = 'ADMINISTRATION_USERS_LIST_CONDITION_LOAD_SERVER_ERROR';
	static ADMINISTRATION_USERS_CREATE_USER_ALREADY_PRESENT: string = 'USER_ALREADY_PRESENT';
	static ADMINISTRATION_USERS_SAVE_ERROR: string = 'ADMINISTRATION_USERS_SAVE_ERROR';
	static ADMINISTRATION_USERS_SAVE_SUCCESS: string = 'ADMINISTRATION_USERS_SAVE_SUCCESS';
	static ADMINISTRATION_USER_MODIFICATION: string = 'ADMINISTRATION_USER_MODIFICATION';
	static ADMINISTRATION_USERS_FILEDS_MISSING: string = 'ADMINISTRATION_USERS_FILEDS_MISSING';
	static ADMINISTRATION_USERS_FILEDS_NETWORK_ERROR: string = 'ADMINISTRATION_USERS_FILEDS_NETWORK_ERROR';
	static ADMINISTRATION_USER_MODIFICATION_SUCCESS: string = 'ADMINISTRATION_USER_MODIFICATION';
	static ADMINISTRATION_USER_MODIFICATION_ERROR: string = 'ADMINISTRATION_USER_MODIFICATION_ERROR';
	static ADMINISTRATION_USERS_EMAIL_ALREADY_ASSOCIATED_WITH_USER: string = 'EMAIL_ALREADY_ASSOCIATED_WITH_USER';
	static ADMINISTRATION_USERS_VALIDATION_SAVE_ERROR: string ='ADMINISTRATION_USERS_VALIDATION_SAVE_ERROR';

	static DELAY: number = 20000;

	type: string;
	autoDeleteEnable: boolean;
	id: string;
	state: string;
	parameter: any;
	removing: boolean;
	keepAlive: boolean;
	autoDeleteDelay: number;

	constructor(id: string, type: string, parameter: any, autoDeleteEnable?: boolean, keepAlive?: boolean, autoDeleteDelay?: number) {
		this.id = id;
		this.type = type;
		this.autoDeleteEnable = autoDeleteEnable;
		this.parameter = parameter;
		this.removing = false;
		this.keepAlive = keepAlive || false;
		this.autoDeleteDelay = autoDeleteDelay || InnerMessageAdministration.DELAY;
	}
}
